import React, { useState, useEffect } from 'react';
import { Dialog } from '@reach/dialog';
import LoaderButton from './LoaderButton';

type ConfirmModalProps = {
  showModal: boolean;
  handleCancel: () => void;
  handleConfirm: () => Promise<void>;
  confirmLoadingText: string;
  message: string | React.ReactNode;
  title?: string;
  confirmText?: string;
  cancelText?: string;
};


const ConfirmModal = ({
  showModal,
  handleCancel,
  handleConfirm,
  confirmLoadingText,
  title,
  message,
  confirmText,
  cancelText,
}: ConfirmModalProps) => {

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (showModal) {
      setIsOpen(true);
    } else {
      document.querySelector('.c-modal')?.classList.add('closed');
      setTimeout(() => {
        setIsOpen(false);
      }, 350);
    }
  }, [showModal]);

  const handleConfirmModal = async () => {
    setIsLoading(true);
    await handleConfirm();
    setIsLoading(false);
  }

  return (
    <Dialog
      isOpen={isOpen}
      onDismiss={handleCancel}
      className="c-modal"
      aria-label={title || 'confirm modal'}
    >
      <button className="c-btn-icon c-modal__close" onClick={handleCancel}>
        <div className="c-btn__inner">
          <i className="c-btn__icon fa fa-times" />
        </div>
      </button>
      {title ? <h1 className="c-modal__heading"><span>{title}</span></h1> : null}

      <div className={`c-modal__body${!title ? '-no-title' : ''}`}>
        <p>{message}</p>
        <div className="u-margin-top-large flex-center">
          <button
            className="c-btn-outline u-margin-right"
            onClick={handleCancel}
          >
            {cancelText ?? "Cancel"}
          </button>
          <LoaderButton
            className="c-btn"
            onClick={handleConfirmModal}
            isLoading={isLoading}
            text={confirmText ?? "Confirm"}
            loadingText={confirmLoadingText}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmModal;